import { render, staticRenderFns } from "./Casebase.vue?vue&type=template&id=0e38ff5e&scoped=true&"
import script from "./Casebase.vue?vue&type=script&lang=js&"
export * from "./Casebase.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/case.css?vue&type=style&index=0&id=0e38ff5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38ff5e",
  null
  
)

export default component.exports